import { Dropdown } from 'antd';
import React, { useMemo, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import Apis from '../../../../../../api';
import { RootState } from '../../../../../../store/rootReducer';
import HSTable from '../../../../../common/HSTable';
import LoginActions from '../../../../../login/redux/actions';
import MessageActions from '../../../../../message/redux/actions';
import DeleteTeamMember from '../modal/DeleteMember';
import RoleChangeAlert from '../modal/RoleChangeAlert';
import TeamManagementActions from '../redux/actions';
import { TeamMember } from '../redux/types';

interface Props {
    existingTeamMemberList: TeamMember[];
    isConfirm?: boolean;
    title?: string;
    showAction?: boolean;
    showTitle?: boolean;
}
interface RoleChangeProps {
    findAdminRole?: { userUUID: string } | null;
    userData?: { uuid: string };

    showAction?: boolean;
    setOpen: (open: boolean) => void;
    setRoleChange: (roleChange: { userUUID: string; email: string; userName: string; role: string }) => void;
    item: TeamMember;
    handleUpdateRole: (role: string) => void;
}
const RoleChange: React.FC<RoleChangeProps> = ({
    findAdminRole,
    userData,

    showAction,
    setOpen,
    setRoleChange,
    item,
    handleUpdateRole,
}) => {
    return (
        <div className="flex justify-start gap-1 items-center w-full">
            <p className="capitalize">{item.role}</p>
            {findAdminRole?.userUUID === userData?.uuid && item.role !== 'Admin' && showAction && (
                <Dropdown
                    overlay={
                        <div className="role_change_popOver flex flex-col gap-2 p-2">
                            {item.role !== 'Admin' ? (
                                <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                        setOpen(true);

                                        setRoleChange({
                                            userUUID: item.userUUID,
                                            email: item.email,
                                            userName: item.name,
                                            role: 'Admin',
                                        });
                                    }}
                                >
                                    Admin
                                </span>
                            ) : (
                                <span
                                    className="cursor-pointer"
                                    onClick={() => {
                                        handleUpdateRole('Member');
                                    }}
                                >
                                    Member
                                </span>
                            )}
                        </div>
                    }
                    placement="bottomLeft"
                    trigger={['click']}
                    arrow
                >
                    <IoIosArrowDown color="#419a49" className="cursor-pointer" />
                </Dropdown>
            )}
        </div>
    );
};

const ExistingTeamMember: React.FC<Props> = ({
    existingTeamMemberList,
    isConfirm,
    title = '',
    showAction,
    showTitle,
}) => {
    const userData = useSelector((state: RootState) => state.user.user);
    const dispatch = useDispatch();
    const investorData = useSelector((state: RootState) => state.user.investor);
    const user_data = useSelector((state: RootState) => state.user);
    const [roleChangeLoader, setRoleChangeLoader] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    const [roleChange, setRoleChange] = useState<{ userUUID: string; role: string; userName: string; email: string }>({
        userUUID: '',
        role: '',
        userName: '',
        email: '',
    });
    const findAdminRole = useMemo(() => {
        const adminObj = existingTeamMemberList?.find((item) => item.role === 'Admin');
        return adminObj;
    }, [existingTeamMemberList]);

    if (existingTeamMemberList.length === 0) {
        return <></>;
    }

    const handleUpdateRole = (role: string) => {
        const investorId = investorData?.uuid || '';
        setRoleChangeLoader(true);
        Apis.updateTeamMembers(investorId, roleChange.userUUID, role)
            .then(() => {
                dispatch(TeamManagementActions.fetchTeamMembers(investorId));

                const user = { ...user_data };

                if (user.user) {
                    user.user.userType = 'TeamMember';
                }

                dispatch(LoginActions.setUserData({ ...user }));
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setRoleChangeLoader(false);
                setOpen(false);
            });
    };
    const getInvitationStatus = (status: string) => {
        const statusColor = String(status).toLocaleLowerCase();
        const statusObj: any = {
            active: 'Accepted',
            invited: 'Sent',
            '': 'N/A',
        };
        return statusColor ? statusObj[statusColor || ''] || status : 'N/A';
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            render: (_: string, item: TeamMember) => {
                return (
                    <div className="flex  gap-1 item-center">
                        {/* <div className="h-[36px] min-w-[36px] w-[36px] text-base text-white flex  justify-center items-center rounded-full bg-[#406DB6]">
                            {getFirstLetters(item.name || item.role)}
                        </div> */}
                        <div className="md:w-1/2 w-full mr-2">
                            <p className="WorkSans-Semibold text-[#20222B] font-bold">
                                {item.name || '-'} {item.userUUID === userData?.uuid ? `(You)` : null}
                            </p>
                            <span className="text-[#5C5C5C] text-xs">{item.email}</span>
                        </div>
                    </div>
                );
            },
            width: '30%',
            fixed: 'left',
        },
        {
            title: 'Account Type',
            dataIndex: 'investorType',
            render: (investorType: string) => {
                return investorType || 'N/A';
            },
            width: '20%',
        },
        {
            title: 'Role',
            dataIndex: 'role',
            width: '15%',
            render: (_: string, item: TeamMember) => {
                return (
                    <RoleChange
                        findAdminRole={findAdminRole}
                        userData={userData}
                        showAction={showAction}
                        setOpen={setOpen}
                        setRoleChange={setRoleChange}
                        item={item}
                        handleUpdateRole={handleUpdateRole}
                    />
                );
            },
        },
        {
            title: 'Invitation Status',
            dataIndex: 'status',
            width: '20%',
            render: (_: string) => {
                return getInvitationStatus(_);
            },
        },

        {
            title: 'User Status',
            dataIndex: 'userStatus',
            width: '20%',
            // render: (status: string, item: TeamMember) => {
            //     const investorStatus = item.userUUID === userData?.uuid ? userData.status : status;

            //     return (
            //         <div className="flex gap-1 items-center w-full ">
            //             <p>{investorStatus || 'N/A'}</p>
            //         </div>
            //     );
            // },
        },
    ];
    const data =
        existingTeamMemberList
            .filter((e) => (isConfirm ? e.email : e.status === 'Active'))
            ?.sort((a, b) => String(a.role).localeCompare(String(b.role))) || [];
    return (
        <>
            {open && (
                <RoleChangeAlert
                    open={open}
                    setOpen={setOpen}
                    role={roleChange.role || ''}
                    email={roleChange.email}
                    userName={roleChange.userName}
                    userUUID={roleChange.userUUID}
                    newRole={roleChange.role}
                    handleUpdateRole={(role: string) => handleUpdateRole(role)}
                    adminRole={findAdminRole}
                    confirmationLoading={roleChangeLoader}
                />
            )}
            <div className="w-full">
                {showTitle ? <p className="page_title_onboarding">{title}</p> : null}
                <div className="md:block hidden shadow-sm p-4 pt-0 bg-white w-full">
                    <HSTable
                        rowClassName="team_member"
                        columns={columns}
                        data={data}
                        rowKey={(d: TeamMember) => d.userUUID}
                        actions={{
                            fixed: 'true',
                            show: showAction || false,
                            layout: (item: TeamMember) => {
                                return findAdminRole?.userUUID === userData?.uuid && item.role !== 'Admin' ? (
                                    <DeleteTeamMember userUUID={item.userUUID} />
                                ) : (
                                    <>-</>
                                );
                            },
                        }}
                    />
                </div>
            </div>
            <div className="grid sm:grid-cols-2 xs:grid-cols-1 gap-2 md:hidden w-full ">
                {data.map((item: TeamMember) => (
                    <div key={item.userUUID} className="shadow-sm p-4 bg-white">
                        <div className="w-full flex justify-between items-start">
                            <div className="flex  gap-1 item-center">
                                {/* <div className="h-[36px] min-w-[36px] w-[36px] text-base text-white flex  justify-center items-center rounded-full bg-[#406DB6]">
                                    {getFirstLetters(item.name || item.role)}
                                </div> */}
                                <div className="md:w-1/2 w-full mr-2">
                                    <p className="WorkSans-Semibold text-[#20222B] font-bold">
                                        {item.name || '-'} {item.userUUID === userData?.uuid ? `(You)` : null}
                                    </p>
                                    <span className="text-[#5C5C5C] text-xs">{item.email}</span>
                                </div>
                            </div>
                            {findAdminRole?.userUUID === userData?.uuid && item.role !== 'Admin' ? (
                                <DeleteTeamMember userUUID={item.userUUID} />
                            ) : null}
                        </div>
                        <div className="grid grid-cols-2 gap-4 mt-2">
                            <div>
                                <p className="!font-[WorkSans-SemiBold] text-[#0F2240]">Account Type</p>
                                <span>{item.userType || 'N/A'}</span>
                            </div>
                            <div>
                                <p className="!font-[WorkSans-SemiBold] text-[#0F2240]">Role</p>
                                <RoleChange
                                    findAdminRole={findAdminRole}
                                    userData={userData}
                                    showAction={showAction}
                                    setOpen={setOpen}
                                    setRoleChange={setRoleChange}
                                    item={item}
                                    handleUpdateRole={handleUpdateRole}
                                />
                            </div>
                            <div>
                                <p className="!font-[WorkSans-SemiBold] text-[#0F2240]">Invitation Status</p>
                                <span>{getInvitationStatus(item.status)}</span>
                            </div>
                            <div>
                                <p className="!font-[WorkSans-SemiBold] text-[#0F2240]">User Status</p>
                                <span>{item.userUUID === userData?.uuid ? userData.status : item.status || 'N/A'}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default ExistingTeamMember;
